import {
  EditButton,
  Identifier,
  Show,
  ShowActionsProps,
  TabbedShowLayout,
  TopToolbar,
  useRecordContext,
  useResourceDefinition,
} from "react-admin";

import "react-big-scheduler-stch/lib/css/style.css";
import GeneralInfos from "./GeneralInfos";
import SiteConfigurations from "./SiteConfigurations";
import SiteExportButton from "./SiteExportButton";
import SiteLocation from "./SiteLocation";

export const SiteShowActions = (props: ShowActionsProps) => {
  const { hasEdit } = useResourceDefinition(props);
  const record = useRecordContext();
  if (!record) return <></>;
  const { id } = record;
  return (
    <TopToolbar {...props}>
      {hasEdit && <EditButton />}
      {id && <SiteExportButton siteId={id as Identifier} />}
    </TopToolbar>
  );
};

export const SiteShow = () => {
  return (
    <Show actions={<SiteShowActions />}>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="General Infos">
          <GeneralInfos />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Configurations" path="configurations">
          <SiteConfigurations />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Map" path="siteMap">
          <SiteLocation />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};
